import { render, staticRenderFns } from "./MainAnalytics.vue?vue&type=template&id=07a851bc&scoped=true"
import script from "./MainAnalytics.vue?vue&type=script&lang=js"
export * from "./MainAnalytics.vue?vue&type=script&lang=js"
import style0 from "./MainAnalytics.vue?vue&type=style&index=0&id=07a851bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a851bc",
  null
  
)

export default component.exports